import * as t from "io-ts";

export const ActionState = t.union([
  t.literal("action_not_needed"),
  t.literal("action_required"),
  t.literal("action_acknowledged"),
  t.literal("action_taken"),
  t.literal("action_to_follow_up"),
  t.literal("action_resolved"),
]);

export type ActionState =
  | "action_not_needed"
  | "action_required"
  | "action_acknowledged"
  | "action_taken"
  | "action_to_follow_up"
  | "action_resolved";
